export default value => {
  const numberToFormat = +value ?? 0
  return numberToFormat.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}
